const { hourToXLocation } = require("../visualHelperFunctions.js")
const d3 = require("d3");


class MiscVisuals {
    constructor(visualiser) {
        this.visualiser = visualiser;
        this.parentGroup = this.visualiser.projectsSubGroup;

        this.createVisuals();
    }

    createVisuals() {
        this.createGridElements();
        this.createTodayLineElements();
    }

    createGridElements() {
        const params = this.visualiser.params;
        var currHour = hourToXLocation(0, this.visualiser);

        this.gridLinesGroup = this.parentGroup.append("g")
            .attr("class", "gridLinesGroup")
            .attr("transform", `translate(${currHour}, ${0})`);

        var simulationLength = this.visualiser.simulator.params.simulationMaxDurationDays + 1;
        var dayArray = Array.from(Array(simulationLength).keys());

        //Create the lines
        //This can be improved by reusing the same lines and updating them according to the viewport
        this.gridLinesGroup.selectAll("gridLines")
            .data(dayArray)
            .enter()
            .append('line')
            .attr('class', 'gridLines')
            .attr('x1', d => d * 8 * params.xScaling - 0.5)
            .attr('y1', params.gridLinePadding)
            .attr('x2', d => d * 8 * params.xScaling - 0.5)
            .attr('y2', params.paddingTop + 100000)
            .attr("style", "stroke: rgb(200,200,200); stroke-width: 0.5px;  vector-effect: non-scaling-stroke;");

        //Create the numbers per line
        this.gridLinesGroup.selectAll("gridNumbers")
            .data(dayArray)
            .enter()
            .append('text')
            .attr('class', 'gridLines')
            .attr('x', d => d * 8 * params.xScaling)
            .attr('y', params.gridLinePadding - 3)
            .text(d => d)
            .attr("style", "color: rgb(0,0,0); font-size: 0.75em; text-anchor: middle;");
    }

    updateElements(duration) {
        var currHour = hourToXLocation(0, this.visualiser);
        this.gridLinesGroup
            .transition()
            .ease(d3.easeLinear)
            .duration(duration)
            .attr("transform", `translate(${currHour}, ${0})`);
    }

    createTodayLineElements() {

        const params = this.visualiser.params;

        this.parentGroup.select(".todayLine").remove();
        this.todayGroup = this.parentGroup.append('g').attr("class", "todayLine");

        this.todayGroup.append('line')
            .attr('x1', params.paddingLeft)
            .attr('y1', params.todayLinePadding)
            .attr('x2', params.paddingLeft)
            .attr('y2', params.paddingTop + 100000) //Stretch it a long
            .attr("style", "stroke: #5B76DF; stroke-width: 2px; vector-effect: non-scaling-stroke;")
            .attr("pointer-events", "none");

        this.todayBox = this.todayGroup.append("g")
            .attr("transform", `translate(${params.paddingLeft - params.todayBoxWidth / 2}, ${params.todayLinePadding})`).attr("pointer-events", "none");;

        //Add the rounded box
        var todayRect = this.todayBox.append('rect')
            .attr("x", 0)
            .attr("y", 0)
            .attr("width", params.todayBoxWidth)
            .attr("height", params.todayBoxHeight)
            .attr("fill", "#5B76DF")
            .attr("rx", (params.todayBoxHeight / 2).toString()).attr("pointer-events", "none");

        //Add the text element
        this.todayBox.append("text")
            .attr("x", params.todayTextX)
            .attr("y", params.todayTextY)
            .text("TODAY")
            .attr("style", "fill: white;").attr("pointer-events", "none");;
    }
}

module.exports = { MiscVisuals };
